<template>
  <RestaurantEnlistmentList/>
</template>
<script>
import RestaurantEnlistmentList from '@/components/modules/restaurant/enlistment/list'
export default {
  name: 'RestaurantEnlistment',
  components: {
    RestaurantEnlistmentList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/enlistment/list.vue